<template>
    <transition name="fade">
        <div class="hmalt" v-show="hmalttoggle">
            <div class="bag" @click="hmalthide"></div>
            <div class="cont">
                <div class="fzclose" @click="hmalthide">
                    <img src="../assets/images/close.svg" alt="" />
                </div>
                <div class="zhong">
                    <div class="tit font40">{{ hmalt.title }}</div>
                    <form action="" class="form">
                        <div class="jut">
                            <div class="li">
                                <div class="int">
                                    <div class="fztext">
                                        品牌名称
                                        <span>*</span>
                                    </div>
                                    <input type="text" v-model="hmalt.brandName" />
                                </div>
                            </div>
                            <div class="li">
                                <div class="int">
                                    <div class="fztext">
                                        您的称呼
                                        <span>*</span>
                                    </div>
                                    <input type="text" v-model="hmalt.userName" />
                                </div>
                            </div>
                        </div>
                        <div class="jut">
                            <div class="li">
                                <div class="int">
                                    <div class="fztext">
                                        您的联系方式
                                        <span>*</span>
                                    </div>
                                    <input type="text" v-model="hmalt.userPhone" />
                                </div>
                            </div>
                        </div>
                        <button type="submit" class="f_sub" @click="commit">
                            提交
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { saveBrand } from '@/api';
const hmaltParam = {
    title: '请留下您的联系方式',
    brandName: '',
    userName: '',
    userPhone: ''
};
export default {
    components: {},
    props: {
        show: {
            default: false,
            type: Boolean
        },
        type: {
            default: 1,
            type: Number
        }
    },
    data() {
        return {
            // 弹窗数据
            hmalt: { ...hmaltParam },
            hmalttoggle: this.show
        };
    },
    watch: {
        show(nv) {
            this.hmalttoggle = nv;
        }
    },
    mounted() {
        /* 弹窗js */
        let hmalt = document.querySelectorAll('.hmalt .cont .form .jut .li .int input');
        for (let i = 0; i < hmalt.length; i++) {
            hmalt[i].onblur = function() {
                if (hmalt[i].value == '') {
                    hmalt[i].previousSibling.style.display = 'flex';
                }
            };
            hmalt[i].onfocus = function() {
                if (hmalt[i].value == '') {
                    hmalt[i].previousSibling.style.display = 'none';
                }
            };
        }
    },
    methods: {
        hmalthide() {
            this.hmalttoggle = !this.hmalttoggle;
            if (!this.hmalttoggle) {
                this.$emit('hiddenToggle');
            }
        },
        commit() {
            if (!this.hmalt.brandName) {
                this.$message.info('请填写品牌名称');
                return;
            }
            if (!this.hmalt.userName) {
                this.$message.info('请填写您的称呼');
                return;
            }
            if (!this.hmalt.userPhone) {
                this.$message.info('请填写您的联系方式');
                return;
            }
            saveBrand({
                brandName: this.hmalt.brandName,
                userName: this.hmalt.userName,
                userPhone: this.hmalt.userPhone,
                type: this.type
            }).then(res => {
                if (res.data) {
                    this.$message.success('提交成功');
                    this.hmalthide();
                    this.hmalt = { ...hmaltParam };
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
